<template>
  <div class="plp-container" :class="mainComputedClasses">
    <div class="grid-container" :class="{'mb-6': marqueeData?.body}">
      <trek-marquee :marquee="marqueeData" :is-simplified="true"></trek-marquee>
    </div>

    <!-- Default cms slots -->
    <slot></slot>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import TrekMarquee from '@/components/TrekMarquee';
import {PdlIcon} from '@pedal/pdl-icon';

export default {
  name: 'PlpContainer',

  components: {
    TrekMarquee,
    // eslint-disable-next-line vue/no-unused-components
    PdlIcon,
  },

  props: {
    marqueeData: {
      type: Object,
      default: () => null,
    },
  },

  computed: {
    mainComputedClasses() {
      return this.marqueeData?.body ? 'mt-4' : 'mt-0';
    },
  },

  mounted() {
    this.updateLastPlp();
  },
  methods: {
    ...mapActions('storage', ['updateLastPlp']),
  },
};
</script>
